/**
 * Small helper to allow multiple listeners to respond to the
 * planyo on_planyo_form_loaded global callback without overwriting.
 *
 * Usage:
 * import { registerPlanyoFormLoaded } from './modules/planyo-form-callbacks';
 * registerPlanyoFormLoaded(fn);
 */

export function registerPlanyoFormLoaded(cb) {
    if (typeof window === 'undefined') return;

    if (!window.__planyoFormLoadedCallbacks) {
        window.__planyoFormLoadedCallbacks = [];

        // Master handler that planyo will call. It will dispatch to all registered callbacks.
        window.on_planyo_form_loaded = function (payload) {
            try {
                window.__planyoFormLoadedCallbacks.forEach(function (fn) {
                    try {
                        fn(payload);
                    } catch (err) {
                        // Keep other callbacks running even if one fails
                        console.error('planyo callback error', err);
                    }
                });
            } catch (err) {
                console.error('planyo master handler error', err);
            }
        };
    }

    if (typeof cb === 'function') {
        window.__planyoFormLoadedCallbacks.push(cb);
    }
}
